module.exports = __webpack_public_path__ + "static/media/NotifyGuestScreen.3d1f2efd.png";